const audiCodeRegEx = /^[A-Z0-9]+$/;
const carLineRegEx = /^[a-z0-9_-]+$/;
export const isAudiCode = (value) => audiCodeRegEx.test(value);
export const isCarLine = (value) => carLineRegEx.test(value);
//# sourceMappingURL=utils.js.map